import { apiInstance, apiInstanceUnauthorized } from 'api/utils';

export default {
  getQuestionnares: () =>
    apiInstance.request({
      method: 'GET',
      url: `/firm/risk-questionnaire/`
    }),
  saveQuestionnare: ({
    customerId,
    data
  }: {
    customerId?: number;
    data: any;
  }) =>
    apiInstance.request({
      method: 'POST',
      url: `/customers/${customerId}/risk-questionnaires/`,
      data: data
    }),
  getCustomerQuestionnare: ({ customerId }: { customerId: number }) =>
    apiInstance.request({
      method: 'GET',
      url: `/customers/${customerId}/risk-questionnaires/?current=1`
    }),
  downloadQuestionnare: ({
    customerId,
    questionnaireId,
    questionnaire2Id,
    caseId,
    images,
    docType,
    downloadType
  }: {
    customerId: number;
    questionnaireId: number | null;
    questionnaire2Id: number | null;
    caseId: number;
    images?: any;
    docType?: string;
    downloadType?: string;
  }) =>
    apiInstance.request({
      method: 'POST',
      url: `/customers/${customerId}/risk-questionnaires/download/`,
      responseType: 'blob',
      data: {
        case_id: caseId,
        questionnaire_id: questionnaireId,
        questionnaire2_id: questionnaire2Id,
        ...images,
        docType: docType,
        download_type: downloadType
      }
    }),
  downloadBlankQuestionnaire: ({ customerId }: { customerId: number }) =>
    apiInstance.request({
      method: 'GET',
      url: `/customers/${customerId}/risk-questionnaires/download/`,
      responseType: 'blob'
    }),
  blankQuestionnaire: (questionnaireType?: string) =>
    apiInstance.request({
      method: 'GET',
      url: `/blank-questionnaire${
        questionnaireType ? `?questionnaireType=${questionnaireType}` : ''
      }`,
      responseType: 'blob'
    }),
  getEmailedCustomerQuestionnaire: (token: string, organization: string) => {
    return apiInstanceUnauthorized.request({
      method: 'GET',
      url: `/${organization}/atr/get/${token}/`
    });
  },
  getEmailedCustomerCflQuestionnaire: (token: string, organization: string) => {
    return apiInstanceUnauthorized.request({
      method: 'GET',
      url: `/${organization}/atr/get/cfl/${token}/`
    });
  },
  getEmailedCustomerExperienceQuestionnaire: (
    token: string,
    organization: string
  ) => {
    return apiInstanceUnauthorized.request({
      method: 'GET',
      url: `/${organization}/atr/get/experience/${token}/`
    });
  },
  sendEmailQuestionnaire: ({
    customer_id,
    company_name,
    company_schema,
    customer_email,
    user_email,
    case_id,
    include_cfl
  }: {
    customer_id: number;
    company_name: string;
    company_schema: string;
    customer_email: string;
    user_email: string;
    case_id: number;
    include_cfl: boolean;
  }) =>
    apiInstance.request({
      method: 'POST',
      url: `/atr/`,
      data: {
        customer_id,
        company_name,
        company_schema,
        customer_email,
        user_email,
        case_id,
        include_cfl
      }
    }),
  postEmailedQuestionnaireReponses: (
    organization: string,
    token: string,
    responses: any
  ) =>
    apiInstanceUnauthorized.request({
      method: 'POST',
      url: `/${organization}/atr/post/${token}/`,
      data: responses
    }),
  postEmailedCFLQuestionnaireReponses: (
    organization: string,
    token: string,
    responses: any
  ) =>
    apiInstanceUnauthorized.request({
      method: 'POST',
      url: `/${organization}/atr/post/cfl/${token}/`,
      data: { responses, case_id: responses[0].case }
    }),
  postEmailedExperienceQuestionnaireResponses: (
    organization: string,
    token: string,
    responses: any
  ) =>
    apiInstanceUnauthorized.request({
      method: 'POST',
      url: `/${organization}/atr/post/experience/${token}/`,
      data: { responses, case_id: responses[0].case }
    })
};
